/**
 * Default column-key -> display-label formatter shared by the various
 * "Cols" visibility dropdowns across the app.
 *
 * e.g. 'today_gain_amount' -> 'Today Gain Amount'
 *
 * Pages with abbreviation overrides (e.g. AccountDetails' ACCOUNT_COLUMN_LABELS)
 * should wrap this as a fallback rather than duplicating the split/capitalize logic.
 */
export const formatColumnLabel = (column) =>
  column
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export default formatColumnLabel;
